import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);
import { Injectable } from "@angular/core";

import { Subject, Observable } from "rxjs";

import {
  RatePromiseService,
  SystemConfigPromiseService,
  OrderDataPromiseLookupService,
  ProfilePromiseActionService,
  CcyPromiseLookupService,
  ICcyLookupService,
  TableModelObject,
  ActiveUserProfilePromiseService,
  ActiveUser,
} from "../../../shared/cubiq-services/index";
import { BfxBlotterOrdersService } from "../../bfx-blotter-orders/bfx-blotter-orders.service";

import { AlgoMonitorDefinitionFactory } from "shared/cubiq-services/model/AlgoMonitorDefinitionFactory";
import { RateCache } from "shared/cubiq-services/rate/impl/RateCache";
import { OrderType } from "shared/cubiq-model-multi-asset";

@Injectable()
export class BfxAlgoMonitorService extends BfxBlotterOrdersService {
  private invertPairSubject: Subject<TableModelObject[]> = new Subject();
  public invertPair$: Observable<TableModelObject[]> = this.invertPairSubject.asObservable();
  private currencyBaseService: ICcyLookupService;

  constructor(
    protected rateService: RatePromiseService,
    protected systemConfigService: SystemConfigPromiseService,
    public dataService: OrderDataPromiseLookupService,
    public tableDefinitionFactory: AlgoMonitorDefinitionFactory,
    protected profileActionService: ProfilePromiseActionService,
    rateCache: RateCache,
    currencyPromiseService: CcyPromiseLookupService,
    activeUserService: ActiveUserProfilePromiseService,
  ) {
    super(
      rateService,
      rateCache,
      systemConfigService,
      dataService,
      tableDefinitionFactory,
      profileActionService,
      activeUserService,
    );

    this.currencyBaseService = currencyPromiseService.getBase();
  }

  protected initData(primed: boolean): void {
    if (!primed) {
      this.rejectPriming(
        this._readyResFn,
        this._readyRejFn,
        Error(`${this.constructor.name}.dataService.isPrimed() returned false`),
      );
      return;
    }

    this.activeUserService.getActiveUserData().then((activeUser: ActiveUser) => {
      this.dataService.getAll().then(
        (rows: any) => {
          this.onInitialPrime(rows);
          this.flushQueuedSubjects();
          this.subscribeToSubject();
          this.resolvePriming(this._readyResFn, this._readyRejFn);
        },
        (error) => {
          this.rejectPriming(this._readyResFn, this._readyRejFn, error);
        },
      );
    });
  }

  protected acceptsRow(row: any): boolean {
    return row?.orderType === OrderType.ALGO || row?.orderType === OrderType.BMALGO;
  }
}
